import React from 'react';
import { Instagram } from 'lucide-react';

/**
 * InstagramFeed — a compact IG-style photo grid between Percorso and the footer.
 * Photos are pre-sliced from the mood-board provided by the user and served
 * from /app/frontend/public/images/ig.
 */
const HANDLE = '@lempole.wine';
const PROFILE_URL = 'https://instagram.com/lempole.wine';
const IMAGES = Array.from({ length: 20 }, (_, i) => `${process.env.PUBLIC_URL}/images/ig/ig-${String(i).padStart(2, '0')}.webp`);

export default function InstagramFeed() {
  return (
    <section id="chapter-instagram" data-theme="light" className="ig-feed" data-testid="instagram-feed">
      <div className="ig-feed__header">
        <a
          href={PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="ig-feed__handle"
          data-testid="ig-handle"
        >
          <Instagram size={20} strokeWidth={1.6} />
          <span>{HANDLE}</span>
        </a>
        <p className="ig-feed__tagline">Frammenti di Lempole, un post alla volta.</p>
      </div>

      <div className="ig-feed__grid">
        {IMAGES.map((src, i) => (
          <a
            key={i}
            href={PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ig-feed__tile"
            data-testid={`ig-tile-${i}`}
            aria-label={`Post Instagram ${i + 1}`}
          >
            <img src={src} alt="" loading="lazy" />
            <span className="ig-feed__hover" aria-hidden="true">
              <Instagram size={22} strokeWidth={1.6} />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
